const initialState = {
  isLoading: true,
  error: null,
  message: null,
  isModalOpen: false,
  modalContent: null,
  propertyId: null,
  isDrawerOpen: false,
  askForLogin: false,
  ticketTitle: null,
  ticketType: null,
  isResponsePopupOpen: false,
  requestId: null,
  type: null,
  title: null
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_TOAST':
      return { ...state, message: action.payload };
    case 'LOADING':
      return { ...state, isLoading: action.payload };
    case 'IS_MODAL_OPEN':
      return { ...state, isModalOpen: action.payload };
    case 'SET_MODAL_CONTENT':
      return { ...state, modalContent: action.payload };
    case 'IS_DRAWER_OPEN':
      return {...state, isDrawerOpen: action.payload.show, propertyId: action.payload ? action.payload.propertyId : null, ticketType: action.payload ? action.payload.type : 'enquiry', ticketTitle: action.payload ? action.payload.title : 'Talk to Agent'};
    case 'ASK_FOR_LOGIN':
      return {...state, askForLogin: action.payload};
    case 'OPEN_RESPONSE_POPUP':
      return {...state, isResponsePopupOpen: action.payload.show, requestId: action.payload.requestId, type: action.payload.type, title: action.payload.title};
    case 'CLOSE_RESPONSE_POPUP':
      return {...state, isResponsePopupOpen: action.payload.show, requestId: null, type: null, title: null};
    default:
      return state;
  }
};

export default uiReducer;
